// Shared message-safety helpers for the AI assistant widgets (staff ChatWidget
// and public PublicAssistantChat). These sanitize model output before it is
// rendered: only code:// citations, vetted navigate:// paths, and http(s)
// links survive.

export function cleanResponseText(text) {
  if (typeof text !== 'string') return '';
  return text
    .replace(/\[\d+:\d+[^\]]*?†[^\]]*?\]/g, '')
    .replace(/\[\d+[^\]]*?†[^\]]*?\]/g, '')
    .trim();
}

function hasControlCharacter(value) {
  for (let index = 0; index < value.length; index += 1) {
    const code = value.charCodeAt(index);
    if (code < 32 || code === 127) return true;
  }
  return false;
}

export function isSafeInternalPath(value) {
  if (typeof value !== 'string') return false;
  const path = value.trim();
  if (!path.startsWith('/') || path.startsWith('//')) return false;
  if (path.length > 300) return false;
  if (path.includes('://') || path.includes('\\')) return false;
  return !hasControlCharacter(path);
}

export function isSafeWebHref(value) {
  if (typeof value !== 'string') return false;
  const href = value.trim();
  if (!href || href.startsWith('//') || hasControlCharacter(href)) return false;
  try {
    const url = new URL(href);
    return ['http:', 'https:', 'mailto:', 'tel:'].includes(url.protocol);
  } catch (error) {
    return false;
  }
}

export function safeUrlTransform(value) {
  if (typeof value !== 'string') return '';
  if (/^code:\/\/\d+$/.test(value)) return value;
  if (value.startsWith('navigate://')) {
    const path = value.slice('navigate://'.length);
    return isSafeInternalPath(path) ? value : '';
  }
  return isSafeWebHref(value) ? value : '';
}

export function processMessageContent(text) {
  if (!text) return '';
  let processed = text.replace(/\[Code:\s*(\d+)\]/g, '[Code $1](code://$1)');
  processed = processed.replace(/\[Navigate:\s*(\/[^\]\s)]*)\]\(([^)]+)\)/g, (match, path, label) => {
    if (!isSafeInternalPath(path)) return label;
    return `[${label}](navigate://${path})`;
  });
  return processed;
}
